import withAuth from '../../util/withAuth';
import CategoryMenu from './Component';

const CategoryMenuContainer = withAuth(CategoryMenu);

export default CategoryMenuContainer;
